import { delayAsync } from "@iyio/common";
import { supClient } from "./supabase";

let _store:FileStore|undefined;
export const fileStore=():FileStore=>{
    return _store??(_store=new FileStore());
}

export class FileStore
{
    private _urls:Record<string,string>={}

    /**
     * Uploads a file to the 'accounts' bucket
     */
    public async uploadAsync(path: string, file: File): Promise<string> {
        const { data, error } = await supClient()
            .storage
            .from('accounts')
            .upload(path, file, {
                upsert: true // This allows you to overwrite the file if it exists
            });

        if (error) {
            throw error;
        }

        // Return the path so it can be saved in the database
        return data.path;
    }

    public async getUrlAsync(path:string):Promise<string|undefined>{
        const loaded=this._urls[path];
        if(loaded){
            return loaded;
        }
        await delayAsync(1);
        const url=supClient().storage.from('accounts').getPublicUrl(path).data.publicUrl;

        this._urls[path]=url;
        return url;
    }

    public getUrlSync(path:string):string|undefined{
        const loaded=this._urls[path];
        if(loaded){
            return loaded;
        }
        const url=supClient().storage.from('accounts').getPublicUrl(path).data.publicUrl;

        this._urls[path]=url;
        return url;
    }

    public getCachedUrl(path:string):string|undefined{
        return this._urls[path];
    }
}